import React from 'react';
type CommentAvatarProps = {
  name: string;
  initials: string;
  color: string;
  src?: string;
  size?: 'md' | 'sm';
};
export function CommentAvatar({
  name,
  initials,
  color,
  src,
  size = 'md'
}: CommentAvatarProps) {
  const sizeClass = size === 'md' ? 'h-10 w-10 text-sm' : 'h-8 w-8 text-xs';
  if (src) {
    return <img src={src} alt={`Foto de perfil de ${name}`} className={`mt-0.5 shrink-0 rounded-full bg-brand-blush object-cover ${sizeClass}`} loading="lazy" data-id="element-97" data-mp="1fekz428a7ftt" />;
  }
  return <span className={`mt-0.5 flex shrink-0 items-center justify-center rounded-full font-sans font-semibold text-white ${sizeClass}`} style={{
    backgroundColor: color
  }} aria-hidden="true" data-id="element-98" data-mp="15fn3kfcfum1b">
      {initials}
    </span>;
}